import React, { Component } from 'react';
import PropTypes from 'prop-types';

import passwordValidator from 'component-lib/PasswordValidator';

const validator = passwordValidator();

export function viewLogic(props) {
    const formError = props.isStartedToSetPassword && props.passwordError;

    return {
        ...props,
        formError,
        inputStatuses: formError ? 'error' : '',
        isButtonDisabled:
      props.isButtonDisabled || !props.isStartedToSetPassword || !!props.passwordError,
    };
}

export function stateLogic(VALIDATION_ISSUES) {
    return function stateLogicDecorator(component) {
        class ChangePasswordStateLogic extends Component {
            static propTypes = {
                user: PropTypes.shape({
                    fullName: PropTypes.string.isRequired,
                    username: PropTypes.string.isRequired,
                }).isRequired,
                passwordConfig: PropTypes.shape({
                    onChange: PropTypes.func.isRequired,
                    value: PropTypes.string.isRequired,
                }).isRequired,
                confirmPasswordConfig: PropTypes.shape({
                    onChange: PropTypes.func.isRequired,
                    value: PropTypes.string.isRequired,
                }).isRequired,
            };

            static defaultProps = {
                searchId: null,
            };

            get isStartedToSetPassword() {
                return !!(
                    this.props.passwordConfig.value.length && this.props.confirmPasswordConfig.value.length
                );
            }

            get passwordError() {
                const { passwordConfig, confirmPasswordConfig, user } = this.props;
                const { isValidPassword } = validator.validatePassword(passwordConfig.value);

                if (passwordConfig.value.toLowerCase() === user.username.toLowerCase()) {
                    return VALIDATION_ISSUES.USERNAME_PASSWORD_MATCH;
                } else if (isValidPassword && confirmPasswordConfig.value !== passwordConfig.value) {
                    return VALIDATION_ISSUES.DOES_NOT_MATCH;
                } else if (!isValidPassword) {
                    return VALIDATION_ISSUES.PASSWORD_COMPLEXITY;
                }

                return false;
            }

            render() {
                return React.createElement(component, {
                    ...this.props,
                    isStartedToSetPassword: this.isStartedToSetPassword,
                    passwordError: this.passwordError,
                });
            }
        }

        return ChangePasswordStateLogic;
    };
}
